<label [for]="'search-' + column()" class="search-menu-element">
  <input
    #search
    [id]="'search-' + column()"
    type="text"
    [value]="value() ?? ''"
    [placeholder]="placeholder()"
    (input)="setSearchValue(search.value)"
  />
  <kin-icon name="search" />
</label>
